import i18n from 'modules/core/lib/i18n'

import { ALL_TYPES } from 'modules/documents/lib/constants'

export default function getTitle(name: string): string {
  switch (name) {
    case ALL_TYPES.adherence:
      return i18n.t('documents.types.adherence')

    case ALL_TYPES.payslip:
    case ALL_TYPES.es_payslip:
    case ALL_TYPES.fr_payslip:
      return i18n.t('documents.types.payslip')

    case ALL_TYPES.payslip_summary:
    case ALL_TYPES.es_payslip_summary:
    case ALL_TYPES.fr_payslip_summary:
      return i18n.t('documents.types.payslip_summary')

    case ALL_TYPES.es_payroll_export:
    case ALL_TYPES.fr_payroll_export:
      return i18n.t('documents.types.payroll_export')

    case ALL_TYPES.contract:
      return i18n.t('documents.types.contract')

    case ALL_TYPES.hiring:
      return i18n.t('documents.types.hiring')

    case 'id-document':
      return i18n.t('documents.types.id-document')

    case ALL_TYPES.novation:
      return i18n.t('documents.types.novation')

    case ALL_TYPES.sick_leave:
      return i18n.t('documents.types.sick-leave')

    case ALL_TYPES.tax:
      return i18n.t('documents.types.tax')

    case ALL_TYPES.social_insurance:
      return i18n.t('documents.types.social_insurance')

    case ALL_TYPES.expenses_company:
      return i18n.t('documents.types.expenses')

    case ALL_TYPES.expenses_employee:
      return i18n.t('documents.types.expenses')
    case ALL_TYPES.training_certificates:
      return i18n.t('documents.types.training_certificates')
    case ALL_TYPES.onboarding:
      return i18n.t('documents.types.onboarding')
    default:
      return name
  }
}
